import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { FormGroupBlock } from "./antd";
import { InputNumber } from "antd";

const InputText = (props) => {
    return (
        <FormGroupBlock {...props}>
            <Field name={props.name}>
                {({
                    field, // { name, value, onChange, onBlur }
                    form: { setFieldValue, touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
                    meta,
                }) => (
                    <InputNumber
                        placeholder={props.placeholder}
                        disabled={props.disabled}
                        min={0}
                        max={100}
                        size="medium"
                        defaultValue={field.value}
                        onChange={(value) => setFieldValue(field.name, value)}
                        formatter={(value) => `${value}%`}
                        parser={(value) => value.replace("%", "")}
                    />
                )}
            </Field>
        </FormGroupBlock>
    );
};

InputText.propTypes = {
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
};

export default InputText;
